import { Reducer } from 'redux';
import {
    CANCELLATION_NO_SHOWS_REPORT_GET_START,
    CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS,
    CANCELLATION_NO_SHOWS_REPORT_GET_ERROR,
    CancellationAndNoShowsReportAction
} from 'actions/insights/bookings/cancellationAndNoShows/CancellationAndNoShowsReportActionsTypes';
import {
    CancellationAndNoShowsReportState,
    CancellationAndNoShowsReportStatus,
    emptyCancellationAndNoShowsReport
} from './CancellationAndNoShowsReportState';

const initialState: CancellationAndNoShowsReportState = {
    report: emptyCancellationAndNoShowsReport,
    status: CancellationAndNoShowsReportStatus.Initial,
    loading: false
};

export const CancellationAndNoShowsReportReducer: Reducer<
    CancellationAndNoShowsReportState,
    CancellationAndNoShowsReportAction
> = (state = initialState, action) => {
    switch (action.type) {
        case CANCELLATION_NO_SHOWS_REPORT_GET_START:
            return {
                ...state,
                status: CancellationAndNoShowsReportStatus.Getting,
                loading: true
            };

        case CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS:
            return {
                ...state,
                report: action.payload.report,
                status: CancellationAndNoShowsReportStatus.GettingSuccess,
                loading: false
            };

        case CANCELLATION_NO_SHOWS_REPORT_GET_ERROR:
            return {
                ...state,
                status: CancellationAndNoShowsReportStatus.Error,
                loading: false
            };

        default:
            return state;
    }
};
